import { render, staticRenderFns } from "./TakeAPhotoTemplate.vue?vue&type=template&id=8771f5e2&scoped=true"
import script from "./TakeAPhotoTemplate.vue?vue&type=script&lang=js"
export * from "./TakeAPhotoTemplate.vue?vue&type=script&lang=js"
import style0 from "./TakeAPhotoTemplate.vue?vue&type=style&index=0&id=8771f5e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8771f5e2",
  null
  
)

export default component.exports